import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyPayable = {

    namespaced: true,

    state:
    {
        ...baseStates,

        branches: [],
        branchesLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches,
    },
};
